import React from "react";
import "../../Styles/certified/kaartech.css";

export default function KaarTech() {
  return (
    <>
      <div className="kaar-certified-details-section">
        <div className="kaar-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="kaar-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="kaar-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="kaar-certified-badge"
            />
            <div className="kaar-certified-company-names">
              <a href="https://www.kaartech.com" target="_blank" rel="noopener noreferrer">
                <img src="/assets/kaartech/kaartech.png" alt="Kaar Tech Logo" className="kaar-certified-company-logo" />
              </a>
              <h1 className="kaar-certified-full-name">
                Kaar Technologies India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="kaar-certified-details-right">
            <img
              src="/assets/kaartech/1733904645495.jpg"
              alt="Kaar Tech Office"
              className="kaar-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="kaar-certified-description">
          <h2>
            Why Kaar Technologies India Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            KaarTech is a global digital transformation leader headquartered in Chennai, guided by a clear vision to be the most dependable and trustworthy partner in every customer's transformation journey. 
            The company brings together deep SAP expertise, engineered delivery, and AI-led execution to help enterprises modernize with speed, clarity, and measurable outcomes.<br /><br />
            The company has scaled into a 1,000+ crore INR enterprise with operations spanning 15+ global locations and a talented workforce of around 2600 employees. 
            KaarTech has successfully executed more than 3,200 projects and SAP programs for 440 global customers, establishing itself as a trusted transformation partner across diverse industries and geographies, including MENA, North America, Europe, and the Asia-Pacific region.<br /><br />
            The company boasts a robust track record of executing 75+ SAP S/4HANA digital transformation projects worldwide, positioning it at the forefront of the enterprise transformation wave. 
            KaarTech's proprietary GenAI platform, KTern.AI, enables global enterprises to achieve accelerated and intelligent SAP S/4HANA transformations through hyperautomation and intelligent execution.<br /><br />
            KaarTech is moving beyond traditional ERP consulting to become a comprehensive Enterprise Operating System partner, where forward-deployed engineering, intelligent agents, and blueprint-driven execution deliver orchestrated, measurable, and outcome-focused business transformation. 
            The organization remains focused on building transformation journeys that deliver measurable, long-term enterprise value.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="kaar-certified-info-cards">
          <div className="kaar-certified-info-card">
            <div className="kaar-certified-info-title">COMPANY SIZE</div>
            <div className="kaar-certified-info-value">2690 Employees</div>
          </div>
          <div className="kaar-certified-info-card">
            <div className="kaar-certified-info-title">INDUSTRY</div>
            <div className="kaar-certified-info-value">Information Technology</div>
          </div>
          <div className="kaar-certified-info-card">
            <div className="kaar-certified-info-title">CONNECT</div>
            <div className="kaar-certified-info-icons">
              <span className="kaar-certified-icon-round">
                <a href="https://www.kaartech.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="kaar-certified-icon-round">
                <a href="https://www.youtube.com/user/kaartech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="kaar-certified-icon-round">
                <a href="https://www.facebook.com/kaartech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="kaar-certified-icon-round">
                <a href="https://www.instagram.com/kaar_tech/?hl=en" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="kaar-certified-icon-round">
                <a href="https://www.youtube.com/user/kaartech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/youtube.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="kaar-certified-info-card">
            <div className="kaar-certified-info-title">LOCATION (HQ)</div>
            <div className="kaar-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="kaar-certified-recognition-section">
          <h2 className="kaar-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="kaar-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="kaar-certified-recognition-image"
            />
          </div>
          <div className="kaar-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Kaar Section */}
        <div className="kaar-certified-life-section">
          <h2 className="kaar-certified-life-title">
            Life at Kaar Technologies India Private Limited
          </h2>
          <div className="kaar-certified-life-gallery">
            <div className="kaar-certified-life-col">
              <img src="/assets/kaartech/1763491145513.jpg" alt="Office 1" className="kaar-certified-life-img" />
              <img src="/assets/kaartech/1746804696552.jpg" alt="Meeting 1" className="kaar-certified-life-img" />
            </div>
            <div className="kaar-certified-life-col kaar-certified-life-center">
              <img src="/assets/kaartech/1756723596536.jpg" alt="Main Office" className="kaar-certified-life-img kaar-certified-life-img-large" />
            </div>
            <div className="kaar-certified-life-col">
              <img src="/assets/kaartech/1759501539463.jpg" alt="Office 2" className="kaar-certified-life-img" />
              <img src="/assets/kaartech/kar.jpeg" alt="Meeting 2" className="kaar-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}